import { observer } from "mobx-react-lite";
import React from "react";
import { Button } from "antd";
import { t } from "i18next";
import style from "./AttsHierarchy.module.less";

type PropsControlButtons = {
  onOk?: () => void;
  onReset?: () => void;
};

export const ControlButtons: React.FC<PropsControlButtons> = observer(
  ({ onReset, onOk }) => (
    <div className={style.controllButtons}>
      <Button
        size="large"
        onClick={() => {
          onReset?.();
        }}
      >
        {t("Reset")}
      </Button>
      <Button
        size="large"
        type="primary"
        onClick={() => {
          onOk?.();
        }}
      >
        {t("Apply")}
      </Button>
    </div>
  ),
);
